/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListApiAccounts200ResponseInner
 */
export interface ListApiAccounts200ResponseInner {
    /**
     * UUID of the API account.
     */
    accountId?: string;
    /**
     * Username used for authentication.
     */
    username?: string;
    /**
     * 'sp' = serviceprovider-level access (all clients); 'client' = access scoped to a single client.
     */
    type?: ListApiAccounts200ResponseInnerTypeEnum;
    /**
     * UUID of the client this account is scoped to. Only set when type is 'client'.
     */
    clientId?: string | null;
    /**
     * Display name of the associated client. Only set when type is 'client'.
     */
    clientName?: string | null;
    /**
     * ISO 8601 datetime of when this account was created.
     */
    createdAt?: string;
}


/**
 * @export
 */
export const ListApiAccounts200ResponseInnerTypeEnum = {
    Sp: 'sp',
    Client: 'client',
} as const;
export type ListApiAccounts200ResponseInnerTypeEnum = typeof ListApiAccounts200ResponseInnerTypeEnum[keyof typeof ListApiAccounts200ResponseInnerTypeEnum];


/**
 * Check if a given object implements the ListApiAccounts200ResponseInner interface.
 */
export function instanceOfListApiAccounts200ResponseInner(value: object): value is ListApiAccounts200ResponseInner {
    return true;
}

export function ListApiAccounts200ResponseInnerFromJSON(json: any): ListApiAccounts200ResponseInner {
    return ListApiAccounts200ResponseInnerFromJSONTyped(json, false);
}

export function ListApiAccounts200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListApiAccounts200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'username': json['username'] == null ? undefined : json['username'],
        'type': json['type'] == null ? undefined : json['type'],
        'clientId': json['clientId'] === undefined ? undefined : json['clientId'] === null ? null : json['clientId'],
        'clientName': json['clientName'] === undefined ? undefined : json['clientName'] === null ? null : json['clientName'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function ListApiAccounts200ResponseInnerToJSON(json: any): ListApiAccounts200ResponseInner {
    return ListApiAccounts200ResponseInnerToJSONTyped(json, false);
}

export function ListApiAccounts200ResponseInnerToJSONTyped(value?: ListApiAccounts200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'username': value['username'],
        'type': value['type'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'createdAt': value['createdAt'],
    };
}

